<template>
    <div class="wrapper">
        <div class="main visual-2 doc-profile-main">
            <Header />

            <div class="profile-doctor">
                <div class="doctor-container page-content">

                    <!-- Main Card -->
                    <div class="wizard-card">

                        <div class="page-header mb-4">
                            <h3 class="page-title"><i class="fa-solid fa-clock"></i> Timeslots Settings</h3>
                            <p class="text-muted">Create and manage appointment timeslots</p>
                        </div>

                        <!-- Action Bar with Create Button -->
                        <div class="action-bar mb-4">
                            <div class="align-items-center">
                                <div class="col-md-6">
                                    <div class="d-flex align-items-center">
                                        <button class="btn-theme-primary" @click="openCreateModal">
                                            <i class="fa-solid fa-plus me-2"></i>
                                            Create New Timeslot
                                        </button>
                                        <div class="ms-3 text-muted small">
                                            <i class="fa-solid fa-info-circle me-1"></i>
                                            Click to create a new timeslot
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="d-flex justify-content-end">
                                        <div class="input-group" style="max-width: 300px;">
                                            <span class="input-group-text bg-transparent">
                                                <i class="fa-solid fa-search"></i>
                                            </span>
                                            <input v-model="searchQuery" type="text" class="form-control-theme"
                                                placeholder="Search timeslots..." />
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>

                        <!-- Timeslot Statistics -->
                        <div class="stats-section mb-4">
                            <div class="row g-3">
                                <div class="col-md-3">
                                    <div class="stat-card">
                                        <div class="stat-icon bg-primary">
                                            <i class="fa-solid fa-calendar"></i>
                                        </div>
                                        <div class="stat-content">
                                            <h5>{{ totalTimeslots }}</h5>
                                            <p>Total Timeslots</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-3">
                                    <div class="stat-card">
                                        <div class="stat-icon bg-success">
                                            <i class="fa-solid fa-clock"></i>
                                        </div>
                                        <div class="stat-content">
                                            <h5>{{ formatTotalHours }}</h5>
                                            <p>Total Hours</p>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="stat-card">
                                        <div class="stat-icon bg-success">
                                            <i class="fa-solid fa-bolt"></i>
                                        </div>
                                        <div class="stat-content">
                                            <h5>{{ activeTimeslots }}</h5>
                                            <p>Active</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="stat-card">
                                        <div class="stat-icon bg-info">
                                            <i class="fa-solid fa-user-clock"></i>
                                        </div>
                                        <div class="stat-content">
                                            <h5>{{ uniqueDays }}</h5>
                                            <p>Days Covered</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="stat-card">
                                        <div class="stat-icon bg-warning">
                                            <i class="fa-solid fa-stethoscope"></i>
                                        </div>
                                        <div class="stat-content">
                                            <h5>{{ totalTypes }}</h5>
                                            <p>Appointment Types</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Timeslots List -->
                        <div class="glass-panel">
                            <div class="table-header">
                                <h4 class="panel-title"><i class="fa-solid fa-list me-2"></i> Timeslots List</h4>
                                <div class="table-filters">
                                    <div class="row g-2">
                                        <div class="col-auto">
                                            <select v-model="dayFilter" class="form-select-sm">
                                                <option value="">All Days</option>
                                                <option v-for="day in daysOfWeek" :key="day" :value="day">{{ day }}
                                                </option>
                                            </select>
                                        </div>
                                        <!-- <div class="col-auto">
                                            <select v-model="typeFilter" class="form-select-sm">
                                                <option value="">All Types</option>
                                                <option v-for="type in appointmentTypes" :key="type.id"
                                                    :value="type.id">
                                                    {{ type.label }}
                                                </option>
                                            </select>
                                        </div> -->
                                        <div class="col-auto">
                                            <select v-model="sortBy" class="form-select-sm">
                                                <option value="day">Sort by Day</option>
                                                <option value="startTime">Sort by Time</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Loading State -->
                            <div v-if="isLoading" class="text-center py-5">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p class="mt-3 text-muted">Loading timeslots...</p>
                            </div>

                            <!-- Empty State -->
                            <div v-else-if="filteredTimeslots.length === 0" class="empty-state">
                                <div class="empty-icon">
                                    <i class="fa-solid fa-clock"></i>
                                </div>
                                <h5>No timeslots found</h5>
                                <p class="text-muted">Click "Create New Timeslot" to add your first timeslot</p>
                                <button class="btn-theme-primary mt-3" @click="openCreateModal">
                                    <i class="fa-solid fa-plus me-2"></i>
                                    Create Your First Timeslot
                                </button>
                            </div>

                            <!-- Timeslots Table -->
                            <div v-else class="table-responsive">
                                <table class="table-theme">
                                    <thead>
                                        <tr>
                                            <th>Day</th>
                                            <th>Start Time</th>
                                            <th>End Time</th>
                                            <th>Active</th>
                                            <th>Appointment Types</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="slot in paginatedTimeslots" :key="slot.id">
                                            <td>
                                                <span class="day-badge">{{ slot.day }}</span>
                                            </td>
                                            <td>
                                                <div class="time-display">
                                                    <i class="fa-solid fa-clock me-2 text-primary"></i>
                                                    {{ formatTimeDisplay(slot.startTime) }}
                                                </div>
                                            </td>
                                            <td>
                                                <div class="time-display">
                                                    <i class="fa-solid fa-clock me-2 text-primary"></i>
                                                    {{ formatTimeDisplay(slot.endTime) }}
                                                </div>
                                            </td>

                                            <td>
                                                <span
                                                    :class="slot.active ? 'badge badge-success' : 'badge badge-offline'">{{
                                                        slot.active ? 'Active' : 'Inactive' }}</span>
                                            </td>

                                            <td>
                                                <div class="types-list">
                                                    <span v-for="typeId in slot.appointmentTypeIds" :key="typeId"
                                                        class="type-mini-badge"
                                                        :style="{ backgroundColor: getTypeColor(typeId) + '20', color: getTypeColor(typeId) }">
                                                        {{ getTypeLabel(typeId) }}
                                                    </span>

                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-actions">
                                                    <button class="btn-action" @click="editTimeslot(slot)" title="Edit">
                                                        <i class="fa-solid fa-edit"></i>
                                                    </button>
                                                    <button class="btn-action text-danger" @click="deleteTimeslot(slot)"
                                                        title="Delete">
                                                        <i class="fa-solid fa-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Pagination -->
                            <div v-if="filteredTimeslots.length > 0" class="table-footer">
                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <p class="mb-0 text-muted">
                                            Showing {{ paginatedTimeslots.length }} of {{ filteredTimeslots.length }}
                                            timeslots
                                        </p>
                                    </div>
                                    <div class="col-md-6">
                                        <nav aria-label="Page navigation">
                                            <ul class="pagination justify-content-end mb-0">
                                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                    <button class="page-link" @click="prevPage">
                                                        <i class="fa-solid fa-chevron-left"></i>
                                                    </button>
                                                </li>

                                                <!-- First page + leading ellipsis -->
                                                <li v-if="visiblePages.length && visiblePages[0] > 1" class="page-item">
                                                    <button class="page-link" @click="currentPage = 1">1</button>
                                                </li>
                                                <li v-if="visiblePages.length && visiblePages[0] > 2"
                                                    class="page-item disabled">
                                                    <span class="page-link">&hellip;</span>
                                                </li>

                                                <!-- Visible page range -->
                                                <li v-for="page in visiblePages" :key="page" class="page-item"
                                                    :class="{ active: page === currentPage }">
                                                    <button class="page-link" @click="currentPage = page">{{ page
                                                        }}</button>
                                                </li>

                                                <!-- Trailing ellipsis + last page -->
                                                <li v-if="visiblePages.length && visiblePages[visiblePages.length - 1] < totalPages - 1"
                                                    class="page-item disabled">
                                                    <span class="page-link">&hellip;</span>
                                                </li>
                                                <li v-if="visiblePages.length && visiblePages[visiblePages.length - 1] < totalPages"
                                                    class="page-item">
                                                    <button class="page-link" @click="currentPage = totalPages">{{
                                                        totalPages }}</button>
                                                </li>

                                                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                                    <button class="page-link" @click="nextPage">
                                                        <i class="fa-solid fa-chevron-right"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <FooterView />
        </div>

        <!-- Timeslot Modal -->
        <TimeslotModal :show="showModal" :timeslot="selectedTimeslot" :appointmentTypes="appointmentTypes"
            @close="closeModal" @saved="handleTimeslotSaved" @deleted="handleTimeslotDeleted"
            @fetch-timeslots="fetchTimeslots" :isAppointmentLoading="isAppointmentLoading" />
    </div>
</template>

<script>
import Header from "@/layout/Header.vue";
import FooterView from "@/layout/Footer.vue";
import TimeslotModal from "@/components/timeslots/CreateTimeslotModal.vue"
import { TimeslotService } from "@/services/timeslot.service";
// import { DoctorTimeSlotService } from "@/services/doctor-time-slots.service";
import { AppointmentTypeService } from "@/services/appointmentType.service";

export default {
    name: "TimeslotsManagement",
    components: {
        Header,
        FooterView,
        TimeslotModal
    },
    data() {
        return {
            timeslots: [],
            appointmentTypes: [],
            isLoading: false,
            searchQuery: "",
            dayFilter: "",
            typeFilter: "",
            sortBy: "day",
            currentPage: 1,
            itemsPerPage: 10,

            showModal: false,
            selectedTimeslot: null,
            isAppointmentLoading: false
        };
    },
    computed: {
        filteredTimeslots() {
            let filtered = this.timeslots;

            // Apply search filter
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                filtered = filtered.filter(slot =>
                    slot.day.toLowerCase().includes(query) ||
                    (slot.notes && slot.notes.toLowerCase().includes(query))
                );
            }

            // Apply day filter
            if (this.dayFilter) {
                filtered = filtered.filter(slot => slot.day === this.dayFilter);
            }

            // Apply type filter
            if (this.typeFilter) {
                // filtered = filtered.filter(slot =>
                //     slot.appointmentTypeIds.includes(Number(this.typeFilter))
                // );
                filtered = filtered.filter(slot =>
                    slot.appointmentTypeIds.includes(Number(this.typeFilter))
                );

            }

            // Apply sorting
            filtered.sort((a, b) => {
                if (this.sortBy === "day") {
                    const dayOrder = this.daysOfWeek;
                    return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
                } else if (this.sortBy === "startTime") {
                    return a.startTime.localeCompare(b.startTime);
                }
                return 0;
            });

            console.log("filtered", JSON.parse(JSON.stringify(filtered)))

            return filtered;
        },

        totalPages() {
            return Math.ceil(this.filteredTimeslots.length / this.itemsPerPage);
        },

        visiblePages() {
            const total = this.totalPages || 1;
            const maxVisible = 7;
            const pages = [];

            if (total <= maxVisible) {
                for (let i = 1; i <= total; i++) pages.push(i);
                return pages;
            }

            const half = Math.floor(maxVisible / 2);
            let start = Math.max(1, this.currentPage - half);
            let end = Math.min(total, this.currentPage + half);

            if (start === 1) end = Math.min(total, maxVisible);
            if (end === total) start = Math.max(1, total - maxVisible + 1);

            for (let i = start; i <= end; i++) pages.push(i);
            return pages;
        },

        paginatedTimeslots() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredTimeslots.slice(start, end);
        },

        totalTimeslots() {
            return this.timeslots.length;
        },

        formatTotalHours() {
            const totalMinutes = this.timeslots.reduce((total, slot) => {
                return total + this.calculateDurationMinutes(slot.startTime, slot.endTime);
            }, 0);

            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            if (hours === 0) return `${minutes}m`;
            if (minutes === 0) return `${hours}h`;
            return `${hours}h ${minutes}m`;
        },

        uniqueDays() {
            const days = new Set(this.timeslots.map(slot => slot.day));
            return days.size;
        },

        totalTypes() {
            const allTypes = new Set();
            this.timeslots?.length && this.timeslots.forEach(slot => {
                slot.appointmentTypeIds?.length && slot.appointmentTypeIds.forEach(typeId => allTypes.add(typeId));
            });
            return allTypes.size;
        },

        daysOfWeek() {
            return [
                "Monday", "Tuesday", "Wednesday", "Thursday",
                "Friday", "Saturday", "Sunday"
            ];
        },

        appointmentTypeMap() {
            const map = {};
            this.appointmentTypes.forEach(type => {
                map[type.id] = type;
            });
            return map;
        },

        activeTimeslots() {
            return this.timeslots.filter(slot => slot.active === true).length;
        },

    },
    mounted() {
        this.fetchTimeslots();
        this.fetchAppointmentTypes();
    },
    methods: {
        convertToLocalTime(date, time) {
            if (!time) return null;

            let hours, minutes;

            // ISO format
            if (time.includes("T")) {
                const d = new Date(time);
                if (isNaN(d)) return null;
                hours = d.getUTCHours();
                minutes = d.getUTCMinutes();
            } else {
                const parts = time.split(":");
                if (parts.length < 2) return null;
                [hours, minutes] = parts.map(Number);
            }

            // subtract 6 hours
            hours = hours - 6;

            if (hours < 0) {
                hours += 24;
            }

            const localDate = new Date();
            localDate.setHours(hours);
            localDate.setMinutes(minutes);
            localDate.setSeconds(0);

            return localDate;
        },

        formatTimeDisplay(time) {
            if (!time) return "";

            const localDate = this.convertToLocalTime(null, time);
            if (!localDate) return "";

            return localDate.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            });
        },

        // Replace the existing convertUTCToLocal method
        // convertUTCToLocal(time) {
        //     // Use the same logic as convertToLocalTime
        //     const localDate = this.convertToLocalTime(null, time);
        //     if (!localDate) return "";

        //     // Return as HH:mm for any further processing
        //     const hours = localDate.getHours().toString().padStart(2, "0");
        //     const minutes = localDate.getMinutes().toString().padStart(2, "0");
        //     return `${hours}:${minutes}`;
        // },

        // Keep convertTo12Hour for display if needed
        convertTo12Hour(time) {
            if (!time) return "";
            // If time is already in HH:mm format (like "12:00")
            const [hours, minutes] = time.split(":").map(Number);
            const period = hours >= 12 ? "PM" : "AM";
            const hour12 = hours % 12 || 12;
            return `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
        },
        async fetchTimeslots() {
            this.isLoading = true;
            try {
                const response = await TimeslotService.getAll();
                const data = response.data;
                console.log("data", data);
                if (data.status === 200) {
                    this.timeslots = data.data.data || [];

                    console.log("timeslots", this.timeslots);
                } else {
                    this.$store.commit("toast/NEW", {
                        type: "error",
                        message: data.message || "Failed to fetch timeslots"
                    });
                }
            } catch (error) {
                console.error("Error fetching timeslots:", error);
                this.$store.commit("toast/NEW", {
                    type: "error",
                    message: "An error occurred while fetching timeslots"
                });
            } finally {
                this.isLoading = false;
            }
        },

        openCreateModal() {
            this.selectedTimeslot = null;
            this.showModal = true;
        },

        editTimeslot(slot) {
            // Convert UTC times to LOCAL time strings for the modal
            this.selectedTimeslot = {
                ...slot,
                startTime: this.formatTimeForModal(slot.startTime),  // "18:00" → "12:00"
                endTime: this.formatTimeForModal(slot.endTime)       // "18:15" → "12:15"
            };
            this.showModal = true;
        },

        // Add this helper method to format time for the modal
        formatTimeForModal(time) {
            if (!time) return "";

            // Use your existing convertToLocalTime method
            const localDate = this.convertToLocalTime(null, time);
            if (!localDate) return "";

            // Return as HH:mm string for the modal input
            const hours = localDate.getHours().toString().padStart(2, "0");
            const minutes = localDate.getMinutes().toString().padStart(2, "0");
            return `${hours}:${minutes}`;
        },

        convertToServerTime(time) {
    if (!time) return null;
    
    // Parse the time string (should be in HH:mm format)
    let [hours, minutes] = time.split(":").map(Number);
    
    // ADD exactly 6 hours (hardcoded)
    hours = hours + 6;
    
    // Handle wrap around to next day
    if (hours >= 24) {
        hours = hours - 24;
    }
    
    // Format back to HH:mm
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
},

        closeModal() {
            this.showModal = false;
            this.selectedTimeslot = null;
        },

       handleTimeslotSaved(savedTimeslot) {
    console.log('📦 Saved from modal:', savedTimeslot);
    console.log('⏰ Local time:', savedTimeslot.startTime);
    
    // Convert local time to UTC by adding 6 hours
    const convertedTimeslot = {
        ...savedTimeslot,
        startTime: this.convertToServerTime(savedTimeslot.startTime),
        endTime: this.convertToServerTime(savedTimeslot.endTime)
    };
    
    console.log('🌍 UTC time (local + 6):', convertedTimeslot.startTime, convertedTimeslot.endTime);
    
    // Update local timeslots list
    const index = this.timeslots.findIndex(t => t.id === convertedTimeslot.id);
    if (index !== -1) {
        this.timeslots.splice(index, 1, convertedTimeslot);
    } else {
        this.timeslots.unshift(convertedTimeslot);
    }
    
    this.showModal = false;
    this.selectedTimeslot = null;
},

        handleTimeslotDeleted(timeslotId) {
            // Remove from local list
            this.timeslots = this.timeslots.filter(t => t.id !== timeslotId);
        },

        async deleteTimeslot(slot) {
            if (!confirm(`Are you sure you want to delete the timeslot for ${slot.day} (${this.convertTo12Hour(slot.startTime)} - ${this.convertTo12Hour(slot.endTime)})? This action cannot be undone.`)) {
                return;
            }

            try {
                // Use TimeslotService for delete
                const response = await TimeslotService.delete(slot.id);

                if (response?.success || response?.data?.status === 200) {
                    this.$store.commit("toast/NEW", {
                        type: "success",
                        message: response?.data?.data?.message || "Timeslot deleted successfully!"
                    });

                    // Remove from local list
                    this.timeslots = this.timeslots.filter(t => t.id !== slot.id);
                } else {
                    console.log("response", response);
                    this.$store.commit("toast/NEW", {
                        type: "error",
                        message: response?.data?.data?.message || "Failed to delete timeslot"
                    });
                }
            } catch (error) {
                console.error("Error deleting timeslot:", error);
                const errorMsg = error?.response?.data
                this.$store.commit("toast/NEW", {
                    type: "error",
                    message: errorMsg?.data?.data?.message || errorMsg?.data?.message || "An error occurred while deleting timeslot"
                });
            }
        },

        duplicateTimeslot(slot) {
            const duplicatedSlot = {
                ...slot,
                id: null,
                notes: slot.notes ? `${slot.notes} (Copy)` : "Copy"
            };
            this.selectedTimeslot = duplicatedSlot;
            this.showModal = true;
        },

        getTypeColor(typeId) {
            return this.appointmentTypeMap[typeId]?.color || "#666";
        },

        getTypeLabel(typeId) {
            console.log("type", JSON.stringify(this.appointmentTypeMap[typeId]))
            return this.appointmentTypeMap[typeId]?.description || this.appointmentTypeMap[typeId]?.label || typeId || "Unknown";
        },

        // convertTo12Hour(time24) {
        //     console.log("time24", time24);
        //     if (!time24) return "";
        //     let [hours, minutes] = time24?.split(":").map(Number);
        //     let period = hours >= 12 ? "PM" : "AM";
        //     hours = hours % 12 || 12;
        //     return `${hours}:${minutes?.toString()?.padStart(2, "0")} ${period}`;
        // },

        timeToMinutes(time) {
            console.log("maintime", time);
            if (!time) return 0;
            const [hours, minutes] = time?.split(":").map(Number);
            return hours * 60 + minutes;
        },

        calculateDuration(startTime, endTime) {
            const start = this.timeToMinutes(startTime);
            const end = this.timeToMinutes(endTime);
            const duration = end - start;

            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;

            if (hours === 0) return `${minutes}m`;
            if (minutes === 0) return `${hours}h`;
            return `${hours}h ${minutes}m`;
        },

        calculateDurationMinutes(startTime, endTime) {
            const start = this.timeToMinutes(startTime);
            const end = this.timeToMinutes(endTime);
            return end - start;
        },

        truncateText(text, length) {
            if (!text) return "";
            if (text.length <= length) return text;
            return text.substring(0, length) + "...";
        },

        async fetchAppointmentTypes() {
            this.isAppointmentLoading = true;
            try {
                const hospitalId = this.$store.state.user.currentUser.objectId;
                const response = await AppointmentTypeService.getAll({ hospitalId });
                const data = response.data;

                console.log("Appointment types:", data);

                if (data.status === 200) {
                    this.appointmentTypes = data.data.data || [];
                    console.log("Appointment types:", JSON.parse(JSON.stringify(this.appointmentTypes)));
                } else {
                    this.$store.commit("toast/NEW", {
                        type: "error",
                        message: data.message || "Failed to fetch appointment types"
                    });
                }
            } catch (error) {
                console.error("Error fetching appointment types:", error);
                this.$store.commit("toast/NEW", {
                    type: "error",
                    message: "An error occurred while fetching appointment types"
                });
            } finally {
                this.isAppointmentLoading = false;
            }
        },

        convertUTCToLocal(time) {
            // time = "HH:mm" in UTC
            if (!time) return "";

            const [hours, minutes] = time.split(":").map(Number);

            const now = new Date();

            // Create a UTC date
            const utcDate = new Date(Date.UTC(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                hours,
                minutes,
                0,
                0
            ));

            // Convert to local time
            const localHours = utcDate.getHours().toString().padStart(2, "0");
            const localMinutes = utcDate.getMinutes().toString().padStart(2, "0");

            return `${localHours}:${localMinutes}`;
        }
    },
};
</script>

<style scoped>
.page-title {
    font-size: 24px;
    font-weight: 600;
    color: #0144A6;
}

.wrapper,
.main,
.profile-doctor {
    height: 100vh;
}

.doctor-container {
    height: 50vh;
}

.page-content {
    width: 100%;
    margin: 150px auto;
    padding-bottom: 50px;
}

.wizard-card {
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    padding: 30px;
    height: calc(100vh - 160px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.page-header {
    width: 30%;
}

/* Conversation Header */
.conversation-header {
    display: flex;
    gap: 15px;
    align-items: flex-start;
    background: #f8faff;
    padding: 15px;
    border-radius: 10px;
    border-left: 4px solid #3c78f9;
}

.avatar-assistant {
    width: 40px;
    height: 40px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #3c78f9;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.assistant-bubble {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    line-height: 1.4;
}

/* Action Bar */
.action-bar {
    background: #f8faff;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid #eef2f6;
}

.btn-theme-primary {
    background: #3c78f9;
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
}

.btn-theme-primary:hover {
    background: #2a65e0;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(60, 120, 249, 0.3);
}

.input-group-text {
    background: white;
    border: 1px solid #ddd;
    border-right: none;
    color: #666;
}

/* Glass Panel */
.glass-panel {
    background: #ffffff;
    border: 1px solid #eee;
    border-radius: 20px;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
    margin-bottom: 30px;
}

.panel-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #0144A6;
    margin-bottom: 0;
    display: flex;
    align-items: center;
}

/* Table Header */
.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eef2f6;
}

.table-filters .form-select-sm {
    padding: 6px 12px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: white;
    min-width: 140px;
}

/* Statistics Cards */
.stats-section {
    margin-bottom: 30px;
}

.stat-card {
    background: white;
    border: 1px solid #eef2f6;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    transition: all 0.3s ease;
    height: 100%;
}

.stat-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.stat-icon {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.2rem;
}

.stat-icon.bg-primary {
    background: #3c78f9;
}

.stat-icon.bg-success {
    background: #28a745;
}

.stat-icon.bg-info {
    background: #17a2b8;
}

.stat-icon.bg-warning {
    background: #ffc107;
}

.stat-content h5 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
    color: #0144A6;
}

.stat-content p {
    margin: 5px 0 0 0;
    color: #666;
    font-size: 13px;
}

/* Timeslot specific styles */
.day-badge {
    background: #e9f2ff;
    color: #3c78f9;
    padding: 6px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 12px;
}

.time-display {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.duration-badge {
    background: #f0f5ff;
    color: #0144A6;
    padding: 4px 10px;
    border-radius: 15px;
    font-weight: 600;
    font-size: 12px;
}

.types-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.type-mini-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid currentColor;
}

.patient-count {
    font-weight: 600;
    color: #28a745;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.slot-notes {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #666;
    font-size: 13px;
}

.table-theme {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.table-theme thead {
    background: #f8faff;
}

.table-theme th {
    padding: 15px;
    text-align: left;
    font-weight: 600;
    color: #0144A6;
    border-bottom: 2px solid #eef2f6;
    font-size: 14px;
}

.table-theme td {
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
}

.table-theme tbody tr:hover {
    background: #f8faff;
}

.table-theme tbody tr:last-child td {
    border-bottom: none;
}

.table-actions {
    display: flex;
    gap: 8px;
}

.btn-action {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    transition: all 0.2s;
    cursor: pointer;
}

.btn-action:hover {
    background: #f8faff;
    border-color: #3c78f9;
    color: #3c78f9;
}

.btn-action.text-danger:hover {
    background: #fff5f5;
    border-color: #dc3545;
    color: #dc3545;
}

.btn-action.text-info:hover {
    background: #e6f7ff;
    border-color: #17a2b8;
    color: #17a2b8;
}

/* Empty State */
.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #adb5bd;
}

.empty-icon {
    font-size: 4rem;
    margin-bottom: 20px;
    opacity: 0.5;
}

.empty-state h5 {
    color: #495057;
    margin-bottom: 10px;
}

/* Table Footer */
.table-footer {
    border-top: 1px solid #eee;
    padding-top: 20px;
    margin-top: 20px;
}

.pagination {
    margin-bottom: 0;
}

.page-link {
    border: 1px solid #e0e0e0;
    color: #666;
    padding: 8px 16px;
    margin: 0 4px;
    border-radius: 8px;
    background: white;
}

.page-item.active .page-link {
    background-color: #3c78f9;
    border-color: #3c78f9;
    color: white;
}

.page-link:hover {
    background-color: #f8faff;
    border-color: #3c78f9;
    color: #3c78f9;
}

.page-item.disabled .page-link {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
    .page-header {
        width: 100%;
    }

    .action-bar .row {
        flex-direction: column;
        gap: 15px;
    }

    .table-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    .table-filters .row {
        flex-wrap: wrap;
    }

    .table-responsive {
        overflow-x: auto;
    }

    .table-theme {
        min-width: 800px;
    }

    .stats-section .col-md-3 {
        margin-bottom: 15px;
    }

    .stat-card {
        flex-direction: column;
        text-align: center;
        padding: 15px;
    }
}

.badge-success {
    background-color: #28a745;
    color: white;
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
}

.badge-offline {
    background-color: #adadad;
    color: rgb(0, 0, 0);
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
}
</style>